import React from 'react';

const NotFound = () => {
  return (
    <h1>Página no encontrada.</h1>
  );
}

export default NotFound;
